module.exports = __webpack_public_path__ + "static/celia-frames-5b08f7b46b5aac0620ee65ba736ab9d3.png";